export interface RestDayArgument {
  id?: string
  userID: string
  challengeID: string
  startTime: Date
  endTime: Date
}

export default class RestDay {
  readonly id?: string
  readonly userID: string
  readonly challengeID: string
  readonly startTime: Date
  readonly endTime: Date

  constructor(arg: RestDayArgument) {
    this.id = arg.id
    this.userID = arg.userID
    this.challengeID = arg.challengeID
    this.startTime = arg.startTime
    this.endTime = arg.endTime
  }

  static fromPG(data: any) {
    return new RestDay({
      id: data.id,
      userID: data.user_id,
      challengeID: data.challenge_id,
      startTime: new Date(data.start_time),
      endTime: new Date(data.end_time),
    })
  }

  toPG() {
    const result: any = {
      user_id: this.userID,
      challenge_id: this.challengeID,
      start_time: this.startTime,
      end_time: this.endTime,
    }
    if (this.id) {
      result.id = this.id
    }
    return result
  }

  isActive(): boolean {
    const now = new Date()
    return now >= this.startTime && now <= this.endTime
  }

  static create(
    userID: string,
    challengeID: string,
    durationMs: number = 12 * 60 * 60 * 1000,
  ): RestDay {
    const startTime = new Date()
    const endTime = new Date(startTime.getTime() + durationMs)
    return new RestDay({ userID, challengeID, startTime, endTime, id: undefined })
  }

  static getDurationMs(): number {
    if (process.env.REACT_APP_REST_DAY_DURATION_MINUTES) {
      const minutes = parseInt(process.env.REACT_APP_REST_DAY_DURATION_MINUTES, 10)
      if (!isNaN(minutes) && minutes > 0) {
        return minutes * 60 * 1000
      }
    }

    const isDev = process.env.NODE_ENV === 'development'
    return isDev ? 60 * 1000 : 12 * 60 * 60 * 1000
  }

  static getTimeRemaining(endTime: Date, now: Date = new Date()): number {
    const remaining = endTime.getTime() - now.getTime()
    return Math.max(0, remaining)
  }

  static formatTimeRemaining(ms: number): string {
    const totalSeconds = Math.floor(ms / 1000)
    const hours = Math.floor(totalSeconds / 3600)
    const minutes = Math.floor((totalSeconds % 3600) / 60)
    const seconds = totalSeconds % 60

    const toSegment = (value: number) => value.toString().padStart(2, '0')

    return `${toSegment(hours)}:${toSegment(minutes)}:${toSegment(seconds)}`
  }

  static canStart(count: number, required: number): boolean {
    return count < required
  }

  static getRemainingCount(count: number, required: number): number {
    return Math.max(0, required - count)
  }
}
